import { render, staticRenderFns } from "./AdminReporting.vue?vue&type=template&id=c5a08c7a"
import script from "./AdminReporting.vue?vue&type=script&lang=js"
export * from "./AdminReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports